<template>
	<div class="dankal-image-upload">
		<img @click="previewImg.popup = true" style="width: 200px;height: auto;" class="upload_img" :src="imgDomain+imgUrl" alt="">
			
		<PriviewImgVue :previewImg="previewImg"></PriviewImgVue>
	</div>
</template>

<script>
	import ImageCompressor from 'image-compressor.js';
	import PriviewImgVue from './PriviewImg.vue';
	import {
		uploadImgFile,
		qiniuInfo,
		uploadImg
	} from '@/api/common';
	import {
		mapState,
		mapActions
	} from 'vuex';
	import utils from "@/jslibs/utils";
	import {
		imgDomain
	} from '@/configs/env';

	export default {
		name: 'DankalImageUpload',
		components:{
			PriviewImgVue
		},
		data() {
			return {
				minNum: 0,
				list: [],
				imgDomain,
				toast: '',
				file_type: this.type, //图片还是视频
				showInput: true,
				showImages: false,
				previewImg:{
					popup:false,
					index:0,
					imgList:[]
				}
			}
		},
		created() {
			setTimeout(()=>{
				this.previewImg.imgList.push(this.imgUrl)
			},500)
		},
		props: {
			imgUrl:{
				type: String,
				default: '',
			},
			limit: {
				type: Number,
				default: 5,
			},
			quatity: {
				type: Number,
				default: 0.6,
			},
			type: {
				type: String,
				default: 'image',
			},
			disabled: {
				type: Boolean,
				default: false
			},
			onloadImage: {
				type: String,
				default: ""
			},
			onloadImageList: {
				type: Array,
				require: false,
				default () {
					return []
				}
			},
			isPro: {
				type: Boolean,
				default: false
			},
			isBanner: {
				type: Boolean,
				default: false
			}
		},
		computed: {
			...mapState(['bucket_domain_token'])
		},
		mounted() {
			if (this.onloadImage) {
				this.list.push(this.onloadImage);
			}
			if (this.isBanner) {
				if (this.onloadImage) {
					this.showInput = false;
				}
			}
		},
		methods: {
			...mapActions(['getUrlAndTokenOfImageUpload']),
			onSelected() {
				const {
					limit,
					list
				} = this;

				if (limit && list.length >= limit) {
					this.$message(`只能上传${limit}张图片`)
					return;
				}
				this.$refs.input.click();
			},

			onDeleted(index) {
				this.list.splice(index, 1)
				//不置空 删除之后上传同张图片无法出发change事件
				if (this.isBanner) {
					this.showInput = true;
				}
				this.$refs.input.value = '';
				this.$emit('input', this.list);
			},

			onFileChanged(event) {
				const file = event.target.files[0];
				const {
					type,
					size
				} = file;
				const isLt1M = size / 1024 / 1024 < 1;
				const isLt2M = size / 1024 / 1024 < 2;
				//this.getUrlAndTokenOfImageUpload();
				if (!file) return;
				if (type.indexOf('image') !== -1) {
					this.file_type = 'image'
				}
				if (type.indexOf('video') !== -1) {
					this.file_type = 'video'
				}
				if (this.isBanner) {
					if (type != 'image/jpeg' && type != 'image/png') {
						this.$message("图片上传限制jpg/png文件格式");
						return;
					}
					if (!isLt2M) {
						this.$message("图片上传限制2M");
						return;
					}
				}
				/* 
				 else {
				 	if (type != 'image/jpeg' && type != 'image/png') {
				 		this.$message("图片上传限制jpg/png文件格式");
				 		return;
				 	}
				 	if (!isLt1M) {
				 		this.$message("图片上传限制1M");
				 		return;
				 	}
				 }*/
				this.upload(file);
			},
			async upload(file) {
				//首先获取七牛信息
				console.log(file.name)
				// const {
				// 	data,
				// 	status
				// } = await qiniuInfo();
				// if (status !== 200) return
				const formData = new FormData();
				formData.append('file', file);
				var url = "/common/UploadFile";
				const res = await uploadImgFile(url, formData).catch(() => {});
				if (res.status === 200) {
					if (this.isBanner) {
						this.list = [];
						this.showInput = false;
					}
					this.$refs.input.value = ''
					this.list.push(res.data.result);
					this.$emit('input', this.list);
				}
			},
		},
		watch: {
			isBanner(val) {
				if (val) {
					if (this.onloadImage) {
						this.showInput = false;
					}
				}
			},
			onloadImage(val) {
				if (val) {
					if (this.isBanner) {
						this.list = [];
						this.showInput = false;
					}
					this.list.push(val);
					console.log(val, "图片信息")
				} else {
					this.list = [];
					this.showInput = true;
				}
			},
			onloadImageList: {
				handler(newVal, oldVal) {
					if (newVal.length > 0) {
						this.showImages = true
						this.list = [];
						this.list = newVal;
					} else {
						this.showImages = false
						this.list = []
					}
				},
				immediate: true
				// if (val.length > 0) {
				// 	this.showImages = true
				// 	console.log(val, "list信息")
				// 	this.list = [];
				// 	this.list = val;
				// } else {
				// 	this.list = []
				// }
			}
		}
	};
</script>

<style lang="less" scoped>
	.dankal-image-upload {
		display: flex;
		flex-wrap: inherit;

		p {
			position: relative;
			min-width: 150px;
			min-height: 150px;
			margin: 20px 10px 20px 30px;
			float: left;

			.upload_img {
				width: 150px;
				height: 150px;
				object-fit: cover;
			}

			.close {
				width: 20px;
				height: 20px;
				position: absolute;
				right: 0;
				cursor: pointer;
			}
		}

		.add-box {
			display: flex;
			flex-direction: column;
			padding-left: 20px;
			margin-top: 20px;

			.add {
				width: 150px;
				height: 150px;
			}

			span {
				color: #CFCFCF;
				font-size: .22rem;
			}
		}
	}
</style>